<template>
  <v-autocomplete
      v-model="model"
      :items="items"
      :loading="isLoading"
      chips
      :search-input.sync="search"
      item-text="user_name"
      :label="label"
      :placeholder="placeholder"
      :multiple="multiple"
      prepend-icon="mdi-database-search"
      small-chips
      deletable-chips
  >
  </v-autocomplete>
</template>

<script>
export default {
  name: "SearchUser",
  data: () => ({
    model: [],
    multiple: true,
    isLoading: false,
    search: null,
    entries: [],
    ids: [],
    allIds: new Map(),
    label: "Search User",
    placeholder: "Search For Users",
  }),
  computed: {
    items() {
      return this.entries.map(entry => {
        this.allIds.set(entry.user_name, entry._id)
        return Object.assign({}, entry, {
          user_name: `${entry.user_name}`
        })
      })
    }
  },
  watch: {
    model(val) {
      this.ids = val.map(v => {
        return this.allIds.get(v)
      })

      this.$emit('values', this.ids)
      return val
    },

    async search(val) {
      if (this.isLoading) return
      if (val.length < 3) return

      this.isLoading = true
      await this.$store.dispatch('SEARCH_FOR_USER', { search: val })
      const searchedUsers = this.$store.getters.searchedUsers

      if ((searchedUsers || []).length > 0) {
        if ((this.ids || []).length > 0) {
          const prevSearch = new Map()

          this.entries.forEach(v => {
            prevSearch.set(v._id, v)
          })

          this.ids.forEach(v => {
            const val = prevSearch.get(v)

            if (val) {
              searchedUsers.push(val)
            }
          })
        }

        this.entries = searchedUsers
      }

      this.isLoading = false
    }
  }
}
</script>

<style scoped>

</style>